const IST_OFFSET = "+05:30";

function activationMs(round) {
  const raw = round?.activation_timestamp;
  if (!raw) return null;
  const iso = String(raw).includes("T") ? String(raw) : String(raw).replace(" ", "T");
  const withZone = /(?:Z|[+-]\d\d:?\d\d)$/.test(iso) ? iso : `${iso}${IST_OFFSET}`;
  const started = new Date(withZone).getTime();
  return Number.isNaN(started) ? null : started;
}

export function remainingBuzzerSeconds(round, countdownSeconds) {
  const total = Number(countdownSeconds) > 0 ? Number(countdownSeconds) : 10;
  if (!round || round.status !== "active") return 0;
  const started = activationMs(round);
  if (started == null) return total;
  const elapsed = Math.floor((Date.now() - started) / 1000);
  return Math.max(0, total - elapsed);
}

/**
 * Map the public buzzer status payload onto the player/spectator screen.
 * Backend round status is the source of truth; countdown is derived from it.
 */
export function describeBuzzerRound(config, lastRound, deviceId) {
  const countdownSeconds = Number(config?.countdown_seconds) || 10;
  const status = lastRound?.status;
  const roundId = lastRound?.round_id ?? null;

  if (status === "active") {
    const remaining = remainingBuzzerSeconds(lastRound, countdownSeconds);
    if (remaining <= 0) {
      return { state: "timed_out", countdown: 0, winnerName: "", isWinner: false, roundId };
    }
    return { state: "active", countdown: remaining, winnerName: "", isWinner: false, roundId };
  }

  if (status === "buzzed" || status === "won") {
    const winnerDevice = lastRound?.winner_device_id;
    return {
      state: "buzzed",
      countdown: null,
      winnerName: lastRound?.winner_display_name || "",
      isWinner: !!(deviceId && winnerDevice && String(deviceId) === String(winnerDevice)),
      roundId,
    };
  }

  if (status === "timed_out") {
    return { state: "timed_out", countdown: 0, winnerName: "", isWinner: false, roundId };
  }

  return { state: "locked", countdown: null, winnerName: "", isWinner: false, roundId: null };
}
